import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export type ChatCountryCode = 'CO' | 'MX';

export interface ChatExperimentConfig {
  /** Experiment name registered in the experimentation service. */
  name: string;
  /** Capital city id used when only the country of an anonymous visitor is known. */
  capitalCityIds: Record<ChatCountryCode, number>;
  /** Max wait for the experiment answer before falling back to Freshchat. */
  timeoutMs: number;
  /** Mobile BFF route that proxies the experimentation service. */
  endpoint: string;
}

export const CHAT_EXPERIMENT_CONFIG = new InjectionToken<ChatExperimentConfig>('CHAT_EXPERIMENT_CONFIG', {
  providedIn: 'root',
  factory: () => {
    const { name, capitalCityIds, timeoutMs } = environment.chatExperiment;
    return { name, capitalCityIds, timeoutMs, endpoint: `${environment.hostMobile}/e13n/validate` };
  },
});
